export const position = {
  position: {
    scale: true,
  },
  top: {
    scale: 'space',
  },
  bottom: {
    scale: 'space',
  },
  left: {
    scale: 'space',
  },
  right: {
    scale: 'space',
  },
  zIndex: {
    scale: true,
  },
} as const;
/**
 * NextJS 12.2.5 does not support `satisfies` assertion
 * Once we upgrade NextJS, these should be `as const satisfies ScaleObject`
 */

export type Position = typeof position;
